/**
 * @file Temporary styleguide view while we are nailing down components and structure.
 */

import React from 'react';
import { NavLink, Link } from 'react-router-dom';

import NavBar from '../components/global/NavBar';
import Footer from '../components/global/Footer';
import HeaderDefault from '../components/global/HeaderDefault';
import ContentWrap from '../components/global/ContentWrap';
import ContentHeader from '../components/global/ContentHeader';
import Button from '../components/global/Button';
import FormGroup from '../components/global/FormGroup';
import InputGroup from '../components/global/InputGroup';
import Select from '../components/global/Select';
import Alert from '../components/global/Alert';
import Dropdown from '../components/global/Dropdown';
import MoreOptionsIcon from '../components/icons/MoreOptionsIcon';
import Badge from '../components/global/Badge';
import CustomControl from '../components/global/CustomControl';
import DropdownMenu from '../components/global/DropdownMenu';
import StatusDot from '../components/global/StatusDot';

const StyleguideView = () => (
  <div className="wrapper-main">
    <HeaderDefault />
    <ContentWrap size="lg">
      <ContentHeader title="Section Title">
        <div className="nav-tabs">
          <NavLink
            to="/pro/foo"
            className="nav-tab nav-tab-active"
            activeClassName="nav-tab-active"
          >
            Brand Filters
          </NavLink>

          <NavLink
            to="/pro/foo"
            className="nav-tab"
            activeClassName="nav-tab-active"
          >
            Details
          </NavLink>

          <NavLink
            to="/pro/whatever"
            className="nav-tab"
            activeClassName="nav-tab-active"
          >
            Pricing
          </NavLink>
        </div>
      </ContentHeader>

      <ContentHeader title="Section Title">
        <NavBar>
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link to="/pro/foo" className="nav-link">
                Brand Filters
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/pro/foo" className="nav-link">
                Details
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/pro/whatever" className="nav-link">
                Pricing
              </Link>
            </li>
          </ul>
        </NavBar>
      </ContentHeader>

      <h1>Typography</h1>

      <hr />

      <h1>H1 Title &ndash; Lorem ipsum dolor.</h1>
      <h2>h2 Title &ndash; Lorem ipsum dolor.</h2>
      <h3>h3 Title &ndash; Lorem ipsum dolor.</h3>
      <h4>h4 Title &ndash; Lorem ipsum dolor.</h4>
      <h5>h5 Title &ndash; Lorem ipsum dolor.</h5>
      <h6>h6 Title &ndash; Lorem ipsum dolor.</h6>

      <hr />

      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aut beatae
        debitis eligendi fugit optio repellendus, tenetur. Assumenda corporis ea
        eligendi eos iste, labore magnam nulla quaerat quos ratione, sint
        veritatis?
      </p>

      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aut beatae
        debitis eligendi fugit optio repellendus, tenetur. Assumenda corporis ea
        eligendi eos iste, labore magnam nulla quaerat quos ratione, sint
        veritatis?
      </p>

      <hr />

      <ul>
        <li>Lorem ipsum dolor sit.</li>
        <li>Lorem ipsum dolor sit.</li>
        <li>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consectetur
          deleniti nam nemo rem sint! Amet, soluta!
        </li>
        <li>Lorem ipsum dolor sit.</li>
        <li>Lorem ipsum dolor sit.</li>
      </ul>

      <ol>
        <li>Lorem ipsum dolor sit.</li>
        <li>Lorem ipsum dolor sit.</li>
        <li>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consectetur
          deleniti nam nemo rem sint! Amet, soluta!
        </li>
        <li>Lorem ipsum dolor sit.</li>
        <li>Lorem ipsum dolor sit.</li>
      </ol>

      <hr />
      <h1>Buttons</h1>
      <hr />

      <Button>Button</Button>
      <Button value="Button" />
      <Button href="/pro/albums/123">Button</Button>
      <a href="/123" className="btn btn-primary">
        Button
      </a>
      <Button btnSize="lg">Button Large</Button>
      <Button btnSize="sm">Button Small</Button>
      <Button btnOutline>Button Outline</Button>
      <Button btnStyle="danger">Danger</Button>
      <Button btnStyle="info">Info</Button>
      <Button btnStyle="warning">Warning</Button>
      <Button btnStyle="success">Success</Button>
      <Button btnBlock>Button Block</Button>

      <hr />
      <h1>Form Controls</h1>
      <hr />

      <FormGroup
        id="input1"
        label="This is a label"
        labelNote="(label note)"
        placeholder="Your name"
      />

      <FormGroup id="input2" placeholder="Disabled" disabled />

      <FormGroup id="input2" placeholder="Read Only" readOnly />

      <Select id="select" label="Select label" labelNote="(optional)">
        <option defaultValue>Select something</option>
        <option value="1">Value 1</option>
        <option value="2">Value 2</option>
        <option value="3">Lorem ipsum dolor sit amet.</option>
      </Select>

      <hr />
      <h1>Input Group</h1>
      <hr />

      <InputGroup
        id="input2"
        type="number"
        label="This is a label"
        labelNote="(label note)"
        addon="$"
        placeholder="Moneys!"
      />

      <hr />
      <h1>Alerts</h1>
      <hr />

      <Alert>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis,{' '}
        <a href="/" className="alert-link">
          Some Link
        </a>
        .
      </Alert>

      <Alert type="secondary">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis,{' '}
        <a href="/" className="alert-link">
          Some Link
        </a>
        .
      </Alert>

      <Alert type="success">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis,{' '}
        <a href="/" className="alert-link">
          Some Link
        </a>
        .
      </Alert>

      <Alert type="info">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis,{' '}
        <a href="/" className="alert-link">
          Some Link
        </a>
        .
      </Alert>

      <Alert type="warning" dismissible>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis,{' '}
        <a href="/" className="alert-link">
          Some Link
        </a>
        .
      </Alert>

      <Alert type="danger">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis,{' '}
        <a href="/" className="alert-link">
          Some Link
        </a>
        .
      </Alert>

      <Alert heading="Alert with heading" dismissible>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis,{' '}
        <a href="/" className="alert-link">
          Some Link
        </a>
        .
      </Alert>

      <hr />
      <h1>Dropdowns (deprecated - use `DropdownMenu`)</h1>
      <hr />

      <Dropdown toggleLabel="Dropdown" className="d-inline-block mr-1">
        <a className="dropdown-item" href="/some">
          Action
        </a>
        <a className="dropdown-item" href="/link">
          Another action
        </a>
        <a className="dropdown-item" href="/whatever">
          Something else here
        </a>
      </Dropdown>

      <Dropdown
        toggleLabel="Dropdown small"
        toggleClassName="btn-sm"
        className="d-inline-block mr-1"
      >
        <a className="dropdown-item" href="/some">
          Action
        </a>
        <a className="dropdown-item" href="/link">
          Another action
        </a>
        <a className="dropdown-item" href="/whatever">
          Something else here
        </a>
      </Dropdown>

      <Dropdown
        toggleLabel="Dropdown right"
        toggleStyle="success"
        xpos="right"
        className="d-inline-block mr-1"
      >
        <button className="dropdown-item">Action</button>
        <a className="dropdown-item" href="/link">
          Another action
        </a>
        <a className="dropdown-item" href="/whatever">
          Something else here
        </a>
      </Dropdown>

      <Dropdown
        toggleLabel="Dropdown right"
        toggleStyle="success"
        xpos="right"
        className="d-inline-block mr-1"
        toggle={
          <span>
            Custom toggle <MoreOptionsIcon />
          </span>
        }
      >
        <button className="dropdown-item">Action</button>
        <a className="dropdown-item" href="/link">
          Another action
        </a>
        <a className="dropdown-item" href="/whatever">
          Something else here
        </a>
      </Dropdown>

      <hr />
      <h1>Dropdowns With Popper</h1>
      <hr />

      <DropdownMenu
        toggleLabel="Dropdown"
        toggleClassName="d-inline-block mr-1"
      >
        <a className="dropdown-item" href="/some">
          Action
        </a>
        <a className="dropdown-item" href="/link">
          Another action
        </a>
        <a className="dropdown-item" href="/whatever">
          Something else here
        </a>
      </DropdownMenu>

      <DropdownMenu toggleLabel="Dropdown small" toggleClassName="btn-sm mr-1">
        <a className="dropdown-item" href="/some">
          Action
        </a>
        <a className="dropdown-item" href="/link">
          Another action
        </a>
        <a className="dropdown-item" href="/whatever">
          Something else here
        </a>
      </DropdownMenu>

      <DropdownMenu
        toggleLabel="Dropdown top"
        toggleStyle="success"
        placement="top"
        toggleClassName="d-inline-block mr-1"
      >
        <button className="dropdown-item">Action</button>
        <a className="dropdown-item" href="/link">
          Another action
        </a>
        <a className="dropdown-item" href="/whatever">
          Something else here
        </a>
      </DropdownMenu>

      <DropdownMenu
        toggleLabel="Dropdown right"
        toggleStyle="success"
        placement="right-start"
        toggleClassName="d-inline-block mr-1"
        toggle={
          <span>
            Custom toggle <MoreOptionsIcon />
          </span>
        }
      >
        <button className="dropdown-item">Action</button>
        <a className="dropdown-item" href="/link">
          Another action
        </a>
        <a className="dropdown-item" href="/whatever">
          Something else here
        </a>
      </DropdownMenu>

      <DropdownMenu
        toggleLabel="Position fixed"
        toggleStyle="success"
        toggleClassName="d-inline-block mr-1"
        positionFixed
      >
        <button className="dropdown-item">Action</button>
        <a className="dropdown-item" href="/link">
          Another action
        </a>
        <a className="dropdown-item" href="/whatever">
          Something else here
        </a>
      </DropdownMenu>

      <hr />
      <h1>Badges</h1>
      <hr />

      <Badge badgeSize="lg">Large Badge</Badge>
      <Badge>Normal Badge</Badge>
      <Badge badgeSize="sm">Small Badge</Badge>

      <Badge badgeSize="lg" round>
        Large Badge
      </Badge>
      <Badge round>Normal Badge</Badge>
      <Badge badgeSize="sm" round>
        Small Badge
      </Badge>

      <hr />
      <h1>Custom Controls</h1>
      <hr />

      <CustomControl
        id="1"
        type="checkbox"
        label="Extra extra large checkbox"
        size="xxl"
      />
      <CustomControl
        id="2"
        type="checkbox"
        label="Extra large checkbox"
        size="xl"
      />
      <CustomControl id="3" type="checkbox" label="Large checkbox" size="lg" />
      <CustomControl id="4" type="checkbox" label="Medium Checkbox" size="md" />
      <CustomControl id="5" type="checkbox" label="Small checkbox" size="sm" />

      <hr />
      <h1>Status Dots</h1>
      <hr />

      <StatusDot status="primary" size="xs" className="mr-1" />
      <StatusDot status="success" size="sm" className="mr-1" />
      <StatusDot status="danger" size="md" className="mr-1" />
      <StatusDot status="purple" size="lg" className="mr-1" />
      <StatusDot status="warning" size="xl" className="mr-1" />
    </ContentWrap>
    <Footer />
  </div>
);

export default StyleguideView;
